module.exports = __webpack_public_path__ + "static/media/approvedRequestIcon.e33a9fe6.svg";